import { useAuthContext } from '@/context/AuthContext';
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useAppSelector} from '@/store/hooks.js';

const GET_EXPENSE_REPORT_CATEGORIES = gql`
  query getExpenseReportCategories(   $companyUuid: ID!) {
    expenseReportCategories(
      expenseReportCategoriesRequest: {  companyUuid: $companyUuid }
    ) {
      uuid
      accountingAccountNumber
      label
    }
  }
`;

const useExpenseReportCategories = (language) => {
    const user = useAppSelector((state) => state.auth.currentUser);

    const companyUuid = user.company.uuid;

    const { loading, error, data, refetch } = useQuery(GET_EXPENSE_REPORT_CATEGORIES, {
        variables: {  companyUuid },
        fetchPolicy: "network-only",

    });
    return {
        loading,
        error,
        categories: data?.expenseReportCategories,
        refetch,
    };
};
export default useExpenseReportCategories;
